<template>
  <div>
    <statistics-filters
      @change="handleFilterChange"
      @submit="handleSubmit"
      :date="date"
      :dateRange="dateRange"
      :dataType="dataType"
      :loading="loading"
    />
    <span class="ma-4 font-weight-bold">
      Статистика за
      {{ data[dataType].date || '---' }}
    </span>
    <chats-table
      v-if="dataType === DATA_TYPE.CHATS"
      :data="data[dataType].rows"
      :loading="loading"
    />
    <managers-table
      v-if="dataType === DATA_TYPE.SUPPORTS"
      :data="data[dataType].rows"
      :loading="loading"
    />
    <actions-table
      v-if="dataType === DATA_TYPE.ACTIONS"
      :data="data[dataType].rows"
      :loading="loading"
    />
    <action-aggregates-table
      v-if="dataType === DATA_TYPE.ACTION_AGGREGATES"
      :data="data[dataType].rows"
      :loading="loading"
    />
    <chat-visits-table
      v-if="dataType === DATA_TYPE.CHAT_VISITS"
      :data="data[dataType].rows"
      :loading="loading"
    />
  </div>
</template>

<script>
import { getChatsByDate } from '@/api/admin/chats';
import { getSupportsData } from '@/api/admin/supports';
import { getChatActionEndEventAggregates, getEvents } from '@/api/admin/events';
import StatisticsFilters from './StatisticsFilters.vue';
import ChatsTable from './ChatsTable.vue';
import ManagersTable from './ManagersTable.vue';
import ActionsTable from './ActionsTable.vue';
import ActionAggregatesTable from './ActionAggregatesTable.vue';
import ChatVisitsTable from './ChatVisitsTable.vue';
import { getISODate } from '@/lib/utils';
import { BLOB_CONTAINER_URL, DATE_RANGE, EVENT } from '@/lib/const';
import { DATA_TYPE } from './const';

const { DAY } = DATE_RANGE;

const FETCH_METHOD = {
  [DATA_TYPE.CHATS]: getChatsByDate,
  [DATA_TYPE.SUPPORTS]: getSupportsData,
  [DATA_TYPE.ACTIONS]: async ({ date, dateRange }) => {
    const response = await getEvents({
      type: EVENT.CHAT_ACTION_END,
      date,
      dateRange,
    });

    return {
      data: response.data.map(({ createdAt, data }) => ({
        createdAt,
        ...data,
      })),
    };
  },
  [DATA_TYPE.ACTION_AGGREGATES]: getChatActionEndEventAggregates,
  [DATA_TYPE.CHAT_VISITS]: async ({ date, dateRange, supportId }) => {
    const response = await getEvents({
      type: EVENT.CHAT_EXIT,
      date,
      dateRange,
      supportId,
    });

    return {
      data: response.data.map(({ createdAt, data }) => ({
        createdAt,
        ...data,
      })),
    };
  },
};

export default {
  name: 'Statistics',
  components: {
    ChatsTable,
    ManagersTable,
    StatisticsFilters,
    ActionsTable,
    ActionAggregatesTable,
    ChatVisitsTable,
  },

  data() {
    return {
      DATA_TYPE,
      blobContainerUrl: BLOB_CONTAINER_URL,
      loading: true,

      date: getISODate(new Date()),
      dateRange: DAY,

      data: {
        [DATA_TYPE.CHATS]: {
          date: getISODate(new Date()),
          rows: [],
        },
        [DATA_TYPE.SUPPORTS]: {
          date: '',
          rows: [],
        },
        [DATA_TYPE.ACTIONS]: {
          date: '',
          rows: [],
        },
        [DATA_TYPE.ACTION_AGGREGATES]: {
          date: '',
          rows: [],
        },
        [DATA_TYPE.CHAT_VISITS]: {
          date: '',
          rows: [],
        },
      },
      dataType: DATA_TYPE.CHATS,
    };
  },

  created() {
    this.initialize();
  },

  methods: {
    initialize() {
      (async () => {
        await this.getData();
      })();
    },

    async getData(additionalFilters) {
      try {
        this.loading = true;
        const { data } = await FETCH_METHOD[this.dataType]({
          date: this.date,
          dateRange: this.dateRange,
          ...additionalFilters,
        });

        this.data[this.dataType].rows = data;
        this.data[this.dataType].date = this.date;
      } catch (e) {
        console.error(e);
      } finally {
        this.loading = false;
      }
    },

    handleFilterChange(key, value) {
      this[key] = value;
    },

    async handleSubmit(additionalFilters = {}) {
      await this.getData(additionalFilters);
    },
  },
};
</script>
